"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Card_1 = __importDefault(require("atomicComponents/atoms/Card/Card"));
var Money_1 = __importDefault(require("components/Money"));
var Separator_1 = __importDefault(require("containers/Tools/styles/Separator"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/audit/hooks");
var processExpenditures_1 = require("utils/processExpenditures");
var ordered_1 = require("utils/selectors/ordered");
var SaaSAuditSurvey_1 = __importDefault(require("../SaaSAuditSurvey"));
var SAVE_MIN = 0.045;
var SAVE_MAX = 0.178;
var RequestAuditCard = function () {
    var _a = __read((0, hooks_1.useRequestAudit)('CTA'), 3), requestAudit = _a[0], isRequestingAudit = _a[1], hasRequestedSaasAudit = _a[2];
    var serviceStats = (0, react_redux_1.useSelector)(ordered_1.selectServiceStats);
    var annualSpend = (0, processExpenditures_1.calculateTotalAnnualSpend)(serviceStats || []);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, __assign({ position: "sticky", top: 20, maxWidth: 300, mx: "auto" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { my: 1 } }, { children: (0, jsx_runtime_1.jsx)("strong", { children: "SaaS Audits" }) })), !annualSpend
                ? (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Every company overpays for software, and so do you." }))
                : ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["You\u2019re likely overspending on SaaS by", ' ', (0, jsx_runtime_1.jsxs)("strong", { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: annualSpend * SAVE_MIN, isShortened: "NEW" }), "-", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: annualSpend * SAVE_MAX, isShortened: "NEW" }), "*"] }), " per year"] }))), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { mt: 1 } }, { children: "Let us help you get an accurate number." })), (0, jsx_runtime_1.jsx)(Separator_1.default, {}), !hasRequestedSaasAudit && ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "secondary", fullWidth: true, disabled: isRequestingAudit || hasRequestedSaasAudit, sx: { mb: 1, color: 'common.white' }, onClick: requestAudit }, { children: annualSpend ? 'Audit my SaaS stack' : 'Request a SaaS Audit' }))), hasRequestedSaasAudit
                ? (0, jsx_runtime_1.jsx)(SaaSAuditSurvey_1.default, {})
                : annualSpend > 0 && ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: ["* Based on your annual SaaS spend of ", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: annualSpend, isShortened: "NEW" }), "\u00A0your company size, and industry"] })))] })));
};
exports.default = RequestAuditCard;
